import { BoxProps, InputProps } from '@chakra-ui/react';
import * as yup from 'yup';

export type BaseAddressFields = {
  address: string;
  city: string;
  country: string;
  state: string;
  postCode: string;
  timezone?: string;
  latitude?: number;
  longitude?: number;
};

export type SelectAddressProps = {
  fieldTypePrefix?: string;
  testId?: string;
  inputTitle?: string;
  containerProps?: BoxProps;
  predictionContainerProps?: BoxProps;
  formContainerProps?: BoxProps;
  inputProps?: InputProps;
  addTimezone?: boolean;
  addLatitudeLongitude?: boolean;
  onUpdateSiteImageLink?: (link: string) => void;
};

export const baseAddressSchema = yup.object().shape({
  country: yup.string().not(['0'], '*Country is required').required('*Country is required'),
  city: yup
    .string()
    .required('*City is required')
    .matches(/^[aA-zZ\s]+$/, 'Only letters are allowed for this field'),
  state: yup.string().not(['0'], '*State is required').required('*State is required'),
  postCode: yup
    .string()
    .matches(/^[0-9]+$/, 'Must be only digits')
    .when('country', {
      is: ['Australia', 'New Zealand'],
      then: yup.string().min(4, 'Must be exactly 4 digits').max(4, 'Must be exactly 4 digits'),
    })
    .when('country', {
      is: 'United States',
      then: yup.string().min(5, 'Must be exactly 5 digits').max(5, 'Must be exactly 5 digits'),
    })
    .required('*Post Code is required'),
});
